import { ReactComponent as Avatar } from 'icons/ico-avatar.svg';

function UserDetails({ fullName, email }: { fullName: string; email: string }) {
  return (
    <div className="User-details">
      <div className="User-avatar">
        <Avatar />
      </div>
      <div className="User-data">
        <span className="User-data--username">{fullName}</span>
        <span className="User-data--email">{email}</span>
      </div>
    </div>
  );
}

export { UserDetails };
